import { makeStyles } from "@mui/styles";
import color from "@definitions/mui/color";

const useStyles = makeStyles(() => ({
  backButton: {
    color: color.primary.main,
    display: "flex",
    alignItems: "center",
    gap: 8
  },
  bcSpaced: {
    display: "flex",
    alignItems: "center",
    minHeight: 48,
    paddingTop: 4,
    paddingBottom: 4
  },
  title: {
    fontSize: "24px",
    marginBottom: 20,
    display: "inline-flex",
    alignItems: "center",
  },
}));

export default useStyles;